import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListView } from '@progress/kendo-react-listview';
import { Edit } from 'styled-icons/fluentui-system-filled';
import { Delete } from 'styled-icons/material';
import { newUpdatePlatform } from '../../redux/actions/_initializer_actions';
import { ShowNotification } from "../Notifications";
import { palette } from '../../system/styles/styles';
import ImportUsers from './imports/users';
import AddCompany from './register/company';

export default function GeneralSettings() {
  const platform = useSelector((state) => state.platform);

  const dispatch = useDispatch();

  const [editCarrer, setEditCarrer] = useState({
    editing: false,
    currentIndex: 0,
    carrer: '',
  });
  const [state, setState] = useState({
    autoAcceptJobs: platform.autoAcceptJobs,
    autoAcceptUsers: platform.autoAcceptUsers,
    autoAcceptCompanies: platform.autoAcceptCompanies,
    formQuestion: platform.formQuestion,
    handleIdInput: platform.platformRequiredID ? 'enabled' : platform.showIdField ? 'enabled-visible' : 'disabled',
    handleTypeInput: platform.typeUser ? 'enabled' : platform.showTypeUserField ? 'enabled-visible' : 'disabled',
    companyTypeText: platform.companyTypeText,
    validation: platform.validation
  });
  const [question, setQuestion] = useState(platform.formQuestion);
  const [userTypeText, setUserTypeText] = useState({
    userTypeText: platform.userTypeText,
    idTypeText: platform.idTypeText,
  });
  const [companyForm, setCompanyForm] = useState({
    locationName: platform.linkConfig.locationName,
    data: platform.linkConfig.data,
    companyLine: platform.linkConfig.companyLine,
    companyPhone: platform.linkConfig.companyPhone,
    companyEmployeesNumber: platform.linkConfig.companyEmployeesNumber,
    companyRFC: platform.linkConfig.companyRFC,
    companyAddressProof: platform.linkConfig.companyAddressProof,
  });
  const [notifications, setNotif] = useState({
    vacanciesNotification: platform.vacanciesNotification,
    companiesNotification: platform.companiesNotification,
    usersNotification: platform.usersNotification,
  });
  const [currentPage, setCurrentPage] = useState(2);

  const changeAutoAccept = async (e) => {
    const { name, checked } = e.target;
    await dispatch(newUpdatePlatform({ [name]: checked }));
    setState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  const HandleInputChange = async (e) => {
    const { value } = e.target;
    setQuestion(value);
  };

  const HandleInput = async (e) => {
    const { name, value } = e.target;
    setUserTypeText((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const SubNavigation = (p) => {
    setCurrentPage(p);
  };

  const saveQuestion = async () => {
    dispatch(newUpdatePlatform({ formQuestion: question }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  const saveUserType = (name, val) => {
    dispatch(newUpdatePlatform({ [name]: val }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  const handleInputs = async (e) => {
    const { name, value } = e.target;
    if (name === 'id') {
      const active = value === 'enabled-visible' ? false : value !== 'disabled';
      const visibility = value !== 'disabled';
      setState((prevState) => ({
        ...prevState,
        platformRequiredID: active,
        showIdField: visibility,
        handleIdInput: value,
        validationChangesOn: true,
      }));
      await dispatch(
        newUpdatePlatform({
          platformRequiredID: active,
          showIdField: visibility,
          handleIdInput: value,
        })
      );
      ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
    } else {
      const active = value === 'enabled-visible' ? false : value !== 'disabled';
      const visibility = value !== 'disabled';
      setState((prevState) => ({
        ...prevState,
        typeUser: active,
        showTypeUserField: visibility,
        handleTypeInput: value,
      }));
      await dispatch(
        newUpdatePlatform({
          typeUser: active,
          showTypeUserField: visibility,
          validationChangesOn: true,
          handleTypeInput: value,
        })
      );
      ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
    }
  };

  const SaveCompanyForm = async (e) => {
    const { name, checked } = e.target;
    const newValues = {
      ...companyForm,
      [name]: checked,
    };
    await dispatch(newUpdatePlatform({ linkConfig: newValues }));
    setCompanyForm((prevState) => ({
      ...prevState,
      ...newValues,
    }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  const changeNotification = async (e) => {
    const { name, checked } = e.target;
    await dispatch(newUpdatePlatform({ [name]: checked }));
    setNotif((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  const HandleChangeCarrer = (e) => {
    const { value } = e.target;
    setEditCarrer((prevState) => ({
      ...prevState,
      carrer: value,
    }));
  };

  const handleAdd = async () => {
    if (editCarrer.editing) {
      const tempArray = platform.carrers;
      tempArray[editCarrer.currentIndex] = editCarrer.carrer;
      await dispatch(newUpdatePlatform({ carrers: tempArray }));
      setEditCarrer((prevState) => ({
        ...prevState,
        carrer: '',
        currentIndex: 0,
        editing: false,
      }));
      ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
    } else {
      const newCarrer = editCarrer.carrer;
      const {carrers} = platform;
      carrers.push(newCarrer);
      await dispatch(newUpdatePlatform({ carrers }));
      setEditCarrer((prevState) => ({
        ...prevState,
        carrer: '',
        currentIndex: 0,
        editing: false,
      }));
      ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
    }
  };

  const handleEdit = (c) => {
    const found = platform.carrers[c];
    setEditCarrer((prevState) => ({
      ...prevState,
      carrer: found,
      currentIndex: c,
      editing: true,
    }));
  };

  const handleDelete = (c) => {
    const tempArray = platform.carrers;
    tempArray.splice(c, 1);
    dispatch(newUpdatePlatform({ carrers: tempArray }));
    ShowNotification('success', 'Todo fue actualizado', '¡Listo!');
  };

  return (
    <div className="generalSettingsContainer">
      <div className="generalSettingsNavBar">
        <p className={currentPage === 1 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(1)}>
          General
        </p>
        <p className={currentPage === 2 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(2)}>
          Registro de usuarios
        </p>
        <p className={currentPage === 3 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(3)}>
          Carreras
        </p>
      </div>
      {currentPage === 1 ? (
        <div className="generalSettingsPage">
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Automatización</p>
              <p className="configCardDesc">
                Configura si deseas aceptar usuarios, vacantes o empresas de manera automática
              </p>
            </div>
            <div className="labelsConfigCont">
              <p className="labelConfigL">Selección</p>
              <p className="labelConfigR">Tipo</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={state.autoAcceptJobs}
                  name="autoAcceptJobs"
                  onChange={changeAutoAccept}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Auto aceptar vacantes</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={state.autoAcceptCompanies}
                  name="autoAcceptCompanies"
                  onChange={changeAutoAccept}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Auto aceptar empresas</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={state.autoAcceptUsers}
                  name="autoAcceptUsers"
                  onChange={changeAutoAccept}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Auto aceptar usuarios</p>
            </div>
          </div>
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Notificaciones</p>
              <p className="configCardDesc">Configura si deseas recibir notificaciones para los siguientes casos</p>
            </div>
            <div className="labelsConfigCont">
              <p className="labelConfigLForm">Notificación</p>
              <p className="labelConfigR">Tipo</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={notifications.vacanciesNotification}
                  name="vacanciesNotification"
                  onChange={changeNotification}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Cuando una vacante se publica</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={notifications.companiesNotification}
                  name="companiesNotification"
                  onChange={changeNotification}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Cuando una empresa se registra</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={notifications.usersNotification}
                  name="usersNotification"
                  onChange={changeNotification}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Cuando un usuario se registra</p>
            </div>
          </div>
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Privacidad</p>
              <p className="configCardDesc">
                Configura si deseas que las vacantes y/o noticias de tu plataforma sean visibles para el público en
                general
              </p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={platform.publicVacancies}
                  name="publicVacancies"
                  onChange={changeNotification}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Vacantes visibles al público en general</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={platform.publicPosts}
                  name="publicPosts"
                  onChange={changeNotification}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Noticias visibles al público en general</p>
            </div>
          </div>
        </div>
      ) : null}
      {currentPage === 2 ? (
        <div className="formSettingsPage">
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Configuración</p>
              <p className="configCardDesc">
                Configura el formulario de registro para tus estudiantes o miembros que desean aplicar a las vacantes
              </p>
            </div>
            <label className="formSettingsTitle">Estudiantes</label>
            <div className="labelsConfigCont">
              <p className="labelConfigLForm">Opción</p>
              <p className="labelConfigR">Tipo</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <select className="selectComponent" name="id" value={state.handleIdInput} onChange={handleInputs}>
                  <option value="enabled">Obligatorio</option>
                  <option value="enabled-visible">Opcional</option>
                  <option value="disabled">Desactivado</option>
                </select>
              </div>
              <p className="configCardDescItem">{platform.idTypeText ? platform.idTypeText : 'Matricula o ID'}</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <select
                  className="selectComponent"
                  name="userType"
                  value={state.handleTypeInput}
                  onChange={handleInputs}>
                  <option value="enabled">Obligatorio</option>
                  <option value="enabled-visible">Opcional</option>
                  <option value="disabled">Desactivado</option>
                </select>
              </div>
              <p className="configCardDescItem">Solicitar tipo de usuario</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionArea">
                <input
                  type="checkbox"
                  checked={state.validation}
                  name="validation"
                  onChange={changeAutoAccept}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Pregunta de validación</p>
            </div>
            <div className="configCardSelection">
              <label className="labelTypeUser" />
              <div className="questionContainer">
                <input
                  type="text"
                  className="inputText"
                  value={question}
                  onChange={HandleInputChange}
                  placeholder="Pregunta de validación"
                />
                <button className="saveQuestion" onClick={saveQuestion}>
                  Guardar pregunta
                </button>
              </div>
            </div>
            <div className="configCardSelection">
              <label className="labelTypeUser">Terminología de usuarios</label>
              <div className="questionContainer">
                <input
                  type="text"
                  className="inputText"
                  name="userTypeText"
                  value={userTypeText.userTypeText}
                  onChange={HandleInput}
                  placeholder="Terminologia de usuario"
                />
                <button
                  className="saveQuestion"
                  onClick={() => saveUserType('userTypeText', userTypeText.userTypeText)}>
                  Guardar
                </button>
              </div>
            </div>
            <div className="configCardSelection">
              <label className="labelTypeUser">Terminología de empresas</label>
              <div className="questionContainer">
                <input
                  type="text"
                  className="inputText"
                  name="companyTypeText"
                  value={state.companyTypeText}
                  onChange={handleInputChange}
                  placeholder="Terminologia de usuario"
                />
                <button className="saveQuestion" onClick={() => saveUserType('companyTypeText', state.companyTypeText)}>
                  Guardar
                </button>
              </div>
            </div>
            <div className="configCardSelection">
              <label className="labelTypeUser">Terminología identificador</label>
              <div className="questionContainer">
                <input
                  type="text"
                  className="inputText"
                  value={userTypeText.idTypeText}
                  name="idTypeText"
                  onChange={HandleInput}
                  placeholder="Terminologia de ID"
                />
                <button className="saveQuestion" onClick={() => saveUserType('idTypeText', userTypeText.idTypeText)}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Configuración</p>
              <p className="configCardDesc">
                Configura el formulario de registro para las empresas que quieran publicar sus vacantes
              </p>
            </div>
            <label className="formSettingsTitle">Empresas</label>
            <div className="labelsConfigCont">
              <p className="labelConfigLForm">Opción</p>
              <p className="labelConfigR">Tipo</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.companyRFC}
                  name="companyRFC"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Solicitar RFC</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.companyAddressProof}
                  name="companyAddressProof"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Solicitar comprobante domiciliar</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.companyPhone}
                  name="companyPhone"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Número telefónico de la empresa</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.companyEmployeesNumber}
                  name="companyEmployeesNumber"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Número de empleados de la empresa</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.companyLine}
                  name="companyLine"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Giro de la empresa</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.data}
                  name="data"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Descripción de la empresa</p>
            </div>
            <div className="configCardSelection">
              <div className="selectionAreaForm">
                <input
                  type="checkbox"
                  checked={companyForm.locationName}
                  name="locationName"
                  onChange={SaveCompanyForm}
                  className="checkBox"
                />
              </div>
              <p className="configCardDescItem">Ubicación de la empresa</p>
            </div>
          </div>
          <div className="configCard">
            <div className="configCarTitleCont">
              <p className="configCardTitle">Importar usuarios</p>
              <p className="configCardDesc">
                Para agilizar el proceso de registro para los postulantes puedes importar sus correos. Recuerda respetar
                el formato pre establecido y subir un archivo .csv
              </p>
            </div>
            <div className="configCardSelection">
              <ImportUsers />
            </div>
          </div>
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Agregar empresa</p>
              <p className="configCardDesc">Puedes agregar empresas de manera manual en el siguiente formulario.</p>
            </div>
            <div className="configCardSelection">
              <AddCompany />
            </div>
          </div>
        </div>
      ) : null}
      {currentPage === 3 ? (
        <div className="notificationSettings">
          <div className="configCard">
            <div className="configCardTitleCont">
              <p className="configCardTitle">Carreras o cursos</p>
              <p className="configCardDesc">Aquí puedes agregar todas las carreras y cursos de tu institución</p>
            </div>
            <div className="configCardSelection2">
              <input
                type="text"
                className="inputTextEmpty"
                value={editCarrer.carrer}
                onChange={HandleChangeCarrer}
                placeholder="Agregar curso o carrera"
              />
              <button className="saveQuestion" onClick={handleAdd}>
                Guardar
              </button>
            </div>
            <div className="listContainer">
              <ListView
                dense={false}
                data={platform.carrers}
                style={{ width: '100%' }}
                item={(props) => {
                  const { index, dataItem } = props;
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '50px calc(100% - 100px) 50px',
                      }}>
                      <div
                        style={{
                          width: '25px',
                          height: '25px',
                          backgroundColor: palette.blue,
                          borderRadius: '50%',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          alignSelf: 'center',
                          justifySelf: 'center',
                        }}
                        onClick={() => handleEdit(index)}>
                        <Edit size={20} color="#FFF" />
                      </div>
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                        {dataItem}
                      </p>
                      <div
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: 'transparent',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        onClick={() => handleDelete(index)}>
                        <Delete size={30} color="red" />
                      </div>
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
